var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5999 0.600006C9.5999 0.268635 9.33127 5.72205e-06 8.9999 5.72205e-06C8.66853 5.72205e-06 8.3999 0.268635 8.3999 0.600006V9.95147L5.17417 6.72574C4.93985 6.49142 4.55995 6.49142 4.32564 6.72574C4.09132 6.96005 4.09132 7.33995 4.32564 7.57426L8.57564 11.8243C8.80995 12.0586 9.18985 12.0586 9.42417 11.8243L13.6742 7.57426C13.9085 7.33995 13.9085 6.96005 13.6742 6.72574C13.4398 6.49142 13.06 6.49142 12.8256 6.72574L9.5999 9.95147V0.600006ZM1.2 13.6C1.2 13.2686 0.931371 13 0.6 13C0.268629 13 0 13.2686 0 13.6V15.4C0 17.3882 1.61177 19 3.6 19H14.4C16.3882 19 18 17.3882 18 15.4V13.6C18 13.2686 17.7314 13 17.4 13C17.0687 13 16.8 13.2686 16.8 13.6V15.4C16.8 16.7255 15.7255 17.8 14.4 17.8H3.6C2.27452 17.8 1.2 16.7255 1.2 15.4V13.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d847db2e46f699d8e4ed8c8b0ba8ac01.svg";
export { ForwardRef as ReactComponent };